<app-nav titulo="Detalle de notificación" descripcion="Aqui podrá ver toda la información detallada de la notificación seleccionada.">
    <div class="notification-details">
        <app-data-printer [categories]="categories"></app-data-printer>
        <button mat-raised-button class="garantor-button mini go-back" color="primary" [routerLink]="returnUrl" *ngIf="returnUrl">
            Volver
        </button>
    </div>
</app-nav>
